import { render, staticRenderFns } from "./PopupCustomize.vue?vue&type=template&id=8488ce28&"
import script from "./PopupCustomize.vue?vue&type=script&lang=js&"
export * from "./PopupCustomize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports